import { FC } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import PayerForm from "./PayerForm";
import { CreatePayer, PayerResponse } from "@/domain/payer.interface";

interface PayerDialogProps {
	open: boolean;
	onClose: () => void;
	onSubmit: (data: CreatePayer) => void;
	initialData?: PayerResponse | null;
	isLoading?: boolean;
}

const PayerDialog: FC<PayerDialogProps> = ({
	open,
	onClose,
	onSubmit,
	initialData,
	isLoading = false,
}) => {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
			<DialogTitle>
				{initialData ? "Edit Payer" : "Create New Payer"}
			</DialogTitle>
			<DialogContent>
				<PayerForm
					onSubmit={onSubmit}
					onCancel={onClose}
					initialData={initialData}
					isLoading={isLoading}
				/>
			</DialogContent>
		</Dialog>
	);
};

export default PayerDialog;
